const state = {
  tools: {
    map: {
      distance: false
    }
  }
}

const getters = {
  tools: (state) => state.tools
}

const actions = {
  toAddReport: async ({ commit, dispatch }, report) => {
    commit('setLoading', 'menyimpan laporan')

    await dispatch('authenticatedUpload', {
      method: 'post',
      url: `${window.config.BASEURL_API1}/report`,
      data: report
    })

    commit('unsetLoading')
  },
  toAddZone: async function ({ commit }, data) {
    commit('setLoading', 'menyimpan data zona')

    await this.dispatch('authenticatedUpload', {
      method: 'post',
      url: `${window.config.BASEURL_API1}/zone`,
      data
    })

    commit('unsetLoading')
  }
}

const mutations = {
  setToolMap: (state, tool) => {
    for (let toolName in state.tools.map) {
      state.tools.map[toolName] = toolName === tool.name ? tool.status : false
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
